import { type ActualizarReunionRequest, type CrearReunionRequest, reunionesService } from '@/services/reuniones.service';
import { useCallback, useState } from 'react';

interface UseReunionesResult {
  isSubmitting: boolean;
  crearReunion: (payload: CrearReunionRequest) => Promise<void>;
  actualizarReunion: (reunionId: string, nit: string, payload: ActualizarReunionRequest) => Promise<void>;
  completarReunion: (reunionId: string, nit: string) => Promise<void>;
  cancelarReunion: (reunionId: string, nit: string) => Promise<void>;
}

export function useReuniones(nit: string): UseReunionesResult {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const crearReunion = useCallback(async (payload: CrearReunionRequest) => {
    setIsSubmitting(true);
    try {
      await reunionesService.crear(nit, payload);
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  const actualizarReunion = useCallback(async (reunionId: string, nit: string, payload: ActualizarReunionRequest) => {
    setIsSubmitting(true);
    try {
      await reunionesService.actualizarDeAsesoriaActual(reunionId, nit, payload);
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  const completarReunion = useCallback(async (reunionId: string, nit: string) => {
    setIsSubmitting(true);
    try {
      await reunionesService.completarDeAsesoriaActual(reunionId, nit);
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  const cancelarReunion = useCallback(async (reunionId: string, nit: string) => {
    setIsSubmitting(true);
    try {
      await reunionesService.cancelarDeAsesoriaActual(reunionId, nit);
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  return {
    isSubmitting,
    crearReunion,
    actualizarReunion,
    completarReunion,
    cancelarReunion,
  };
}
